module.exports = __webpack_public_path__ + "static/media/ipay_logo.30468e60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ipay_logo.png
// module id = 312
// module chunks = 0